// extracted by mini-css-extract-plugin
export var legendIndicator = "_d7-1";
export var legendRight = "_d7-0";